import React from 'react'
import './Footer.sass';
import FooterLinks from "./FooterLinks"
import LocalizationService from "../../Services/localization.service";
// @ts-ignore
import sessionStorage from "store/storages/sessionStorage";

interface FooterState {
    activeLanguageCode: string;
    showFooter: boolean;
    loadError: boolean;
    errorMessage: string;
    footerCopyLinks: any;
};

type FooterProps = {
    lang: string;
};

class Footer extends React.Component<FooterProps, FooterState> {
    localizationService: LocalizationService;

    constructor(props: Readonly<FooterProps>) {
        super(props);
        this.localizationService = new LocalizationService();
        let currentLang = props.lang;
        this.state = Object.assign({}, {
            activeLanguageCode: currentLang,
            showFooter: true,
            loadError: false,
            errorMessage: "",
            footerCopyLinks: {}
        });

        const langObj = sessionStorage.read(currentLang);

        if (langObj != null) {
            this.state = Object.assign({}, {
                activeLanguageCode: currentLang,
                showFooter: true,
                loadError: false,
                errorMessage: "",
                footerCopyLinks: JSON.parse(langObj) as string
            });
        }
    }

    sessionKeyName = (lang: string) => {
        return `footer_${lang}`;
    }

    componentDidMount() {
        const { localize } = this.context;
        let dataLoading: [Promise<any>, Promise<any>] = [
            this.localizationService.getStaticFooterContentBundle(LocalizationService.EN),
            this.localizationService.getStaticFooterContentBundle(LocalizationService.JP)
        ];

        Promise.all(dataLoading).then((results: any[]) => {
            let state = {...this.state};
            if (state.activeLanguageCode === LocalizationService.EN) {
                state.footerCopyLinks = results[0];
            } else {
                state.footerCopyLinks = results[1];
            }

            const jpKey = this.sessionKeyName(LocalizationService.JP);
            const enKey = this.sessionKeyName(LocalizationService.EN);
            sessionStorage.write(enKey, JSON.stringify(results[0]));
            sessionStorage.write(jpKey, JSON.stringify(results[1]));

            this.setState(state);
        }).catch((error: any) => {
            // const errMsg = error.message ? `${error.message}` : "Unspecified error";
            const errMsg = error.message ? `${error.message}` : localize('static.content.pwas-search-fatal-error-message');
            this.setState({showFooter: true, loadError: true, errorMessage: errMsg});
            console.error(`Error: ${JSON.stringify(error)}`);
        });
    }

    componentDidUpdate(prevProps: Readonly<FooterProps>, prevState: Readonly<FooterState>) {
        if (this.state.activeLanguageCode !== prevState.activeLanguageCode) {
            let state = {...this.state};
            const theLang = sessionStorage.read(this.sessionKeyName(this.state.activeLanguageCode));
            state.footerCopyLinks = JSON.parse(theLang as string);
            this.setState(state);
        }
    }

    render() {
        return (
            <footer>
                <div className="visible-lg-block visible-md-block visible-sm-block visible-xs-block">
                    <FooterLinks links={this.state.footerCopyLinks}/>
                    {this.state.footerCopyLinks.footerDisclosures &&
                    <div className="yCmsComponent legal-text">
                        {this.state.footerCopyLinks.footerDisclosures.map((disclosure: string, index: number) => {
                            return <p key={index.toString()}>{disclosure}</p>
                        })
                        }
                    </div>
                    }
                </div>
            </footer>
        );
    }
}

export default Footer;



